module.exports = __webpack_public_path__ + "img/checkedRender.a845d7a9.png";